enum Types {
  GET_AUDIT_LOGS_REQUEST = 'GET_AUDIT_LOGS_REQUEST',
  GET_AUDIT_LOGS_FULFILLED = 'GET_AUDIT_LOGS_FULFILLED',
  GET_AUDIT_LOGS_REJECTED = 'GET_AUDIT_LOGS_REJECTED',

  GET_CONTEXT_AUDIT_LOGS_REQUEST = 'GET_CONTEXT_AUDIT_LOGS_REQUEST',
  GET_CONTEXT_AUDIT_LOGS_FULFILLED = 'GET_CONTEXT_AUDIT_LOGS_FULFILLED',
  GET_CONTEXT_AUDIT_LOGS_REJECTED = 'GET_CONTEXT_AUDIT_LOGS_REJECTED',
}

export default Types;
